<template>
  <vue-draggable-resizable
    v-if="isLoaded"
    v-show="isNotHidden"
    :x="boxPosition.x"
    :y="boxPosition.y"
    :w="boxSize.width * boxSize.scale"
    :h="boxSize.height * boxSize.scale"
    :parent="true"
    :resizable="false"
    :key="keyRenderer"
    @dragstop="setChange"
    class="tool-signature-drag"
  >
    <div class="square--custom cursor-move flex justify-center items-center" :class="classes" :style="boxStyle">
      <div class="tool-header flex justify-between items-center">
        <div class="icon-box flex items-center justify-center">
          <zt-icon name="arrows-alt" />
        </div>
        <h3 class="font-14">{{ $t('message.abm.folders.signatureTool.singEmployee') }}</h3>
      </div>
      <div class="font-14 w-full h-full flex justify-between items-center">
        <p class="text-center">
          {{ $t('message.abm.folders.signatureTool.singDescription') }}
        </p>
      </div>
    </div>
  </vue-draggable-resizable>
</template>
<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import { isEmpty } from 'lodash'
import { SQUARE_SIGNATURE_HEIGHT, SQUARE_SIGNATURE_WIDTH } from '../../../../utils/constants'
import { convertLastPage } from '../../../../utils'
export default {
  name: 'SignatureEmployeeTool',
  components: {
    VueDraggableResizable
  },
  inject: [
    'getThumbnailList',
    'modalState',
    'setModalStateProperty',
    'updateToolPanelApplied'
  ],
  props: {
    document: {
      type: Object,
      default: () => ({})
    },
    preset: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      maxWidth: 0,
      maxHeight: 0,
      keyRenderer: 0,
      x: 0,
      y: 0
    }
  },
  computed: {
    documentStyle() {
      const { page: { width, height } } = this.document
      return {
        height: `${height}px`,
        width: `${width}px`
      }
    },
    boxStyle() {
      return {
        height: `${this.boxSize.height}px`,
        width: `${this.boxSize.width}px`,
        transform: `scale3d(${this.boxSize.scale}, ${this.boxSize.scale}, 1)`,
        transformOrigin: '0 0'
      }
    },
    boxSize() {
      const { page: { scale } } = this.document
      const width = SQUARE_SIGNATURE_WIDTH
      const height = SQUARE_SIGNATURE_HEIGHT
      return { width, height, scale }
    },
    boxPosition() {
      const { page: { scale } } = this.document
      return {
        x: this.x * scale,
        y: this.y * scale
      }
    },
    isNotHidden() {
      const { _pdfInfo } = this.document.document
      return this.isLoaded && this.preset.show && convertLastPage(this.preset.page, _pdfInfo.numPages) === this.document.page.pdfPage.pageNum
    },
    isLoaded() {
      return !isEmpty(this.document) && !isEmpty(this.preset)
    },
    classes() {
      return {
        'no-focused-tool': this.isLoaded && !this.modalState.config.employee.isFocused
      }
    }
  },
  watch: {
    document() {
      if (this.isLoaded) {
        const { page: { width, height } } = this.document
        this.maxWidth = width
        this.maxHeight = height
        this.forceRerender()
      }
    },
    preset(value) {
      this.x = value.x
      this.y = value.y
    }
  },
  mounted() {
    if (this.isLoaded) {
      const { page: { width, height } } = this.document
      this.x = this.preset.x
      this.y = this.preset.y
      this.maxWidth = width
      this.maxHeight = height
      this.$nextTick(() => this.forceRerender())
    }
  },
  methods: {
    setChange(x, y) {
      const { page, document: { _pdfInfo } } = this.document
      const newPreset = {
        orientation: this.modalState.config.orientation,
        page: convertLastPage (page.pdfPage.pageNumber, _pdfInfo.numPages , true),
        x: x / page.scale,
        y: y / page.scale
      }
      this.x = x
      this.y = y
      this.setModalStateProperty({ ...this.preset, ...newPreset }, 'employee', 'preset')
      this.updateToolPanelApplied(true, 'signDef')
      this.forceRerender()
    },
    forceRerender() {
      this.keyRenderer += 1
      this.getThumbnailList()
    }
  }
}
</script>
<style scoped lang="scss">
@import "~vue-draggable-resizable/src/components/vue-draggable-resizable.css";
.font-14 {
  font-size: 1.125rem;
}
.tool-header {
  background: #ADE2D2;
  color: #212529;
  position: absolute;
  width: 100%;
  top: -35px;
  user-select: none;
  .icon-box {
    width: 25px;
    height: 25px;
    margin-bottom: 7px;
    i:before {
      font-weight: 800!important;
    }
  }
  h3 {
    font-weight: 600;
    width: calc(100% - 25px);
    text-align: center;
  }
}
.square--custom {
  background: #D9F3EC;
  color: #212529;
  user-select: none;
}
.tool-signature-drag.vdr {
  border: 0 none!important;
}
.no-focused-tool {
  opacity: .7;
}
</style>
